import React from 'react'
import "../styles/PrivacyPolicy.css"
const PrivacyPolicy = () => {
    return (
        <>
            <div className='min-[670px]:m-[4rem] text-justify max-[670px]:text-left max-[670px]:m-[2rem]'>
                <div className='bold text-[35px] text-center'>
                    Privacy Policy
                </div>
                <div className='text-justify mt-10'>
                    This privacy policy explains how YR IT SOLUTIONS Pvt Ltd handles your personal information and data. It applies to all products, services, and websites offered by YR IT SOLUTIONS Pvt Ltd and their affiliates, collectively referred to as "services."
                    <div className=' font-bold text-[36px] mt-10 max-[670px]:text-[28px] max-[670px]:text-left max-[670px]:font-semibold max-[670px]:mt-6 '>
                        INFORMATION WE COLLECT
                    </div>
                    <div className=''>
                        <div className='privacy-sub'>
                            From Our Customers:

                        </div>
                        <div className='ml-2'>
                            <ul className=' list-disc ml-3 '>
                                <li>
                                    Registration Information:

                                    Username, password, and email address.

                                </li>
                                <li>
                                    Billing Information: Name, address, email address, and payment details. YR IT SOLUTIONS Pvt Ltd follows industry standards to protect cardholder data.

                                </li>
                                <li>
                                    Account Settings: Preferences like language, timezone, and communication preferences.

                                </li>
                                <li>

                                    Form Data: Stored data on our servers. Forms are private unless made public by the customer. YR IT SOLUTIONS Pvt Ltd doesn't sell or use form data for unrelated purposes.
                                </li>
                            </ul>
                        </div>
                        <div className=''>
                            <div className='privacy-sub'>
                                From Visitors to Our Websites:

                            </div>
                            <ul className=' list-disc ml-3 '>
                                <li>
                                    Usage Data: Information about website interactions and log files data.

                                </li>
                                <li>

                                    Device Data: IP address, operating system, device type, system info, and browser type.
                                </li>
                                <li>

                                    Referral Data: Information about the source that referred you to our website.
                                </li>
                                <li>

                                    Information from Third Parties: Data shared by third parties with your permission.
                                </li>
                                <li>

                                    Information from Page Tags: Aggregated and anonymized data from tracking services and web beacons.
                                </li>
                            </ul>
                            <div className=''>

                                <div className='privacy-sub'>

                                    From Form Responders:
                                </div>
                                <div className=''>

                                </div>
                                Form Responses: Data submitted in forms, stored on behalf of customers. Form creators manage this data and may have their own privacy policies.
                            </div>
                            <div className='font-semibold  text-[25px] mt-10 max-[670px]:text-[24px] max-[670px]:text-left max-[670px]:font-semibold max-[670px]:mt-6'>

                                HOW WE USE AND DISCLOSE YOUR INFORMATION

                            </div>
                            <div className=''>
                                <div className='privacy-sub'>

                                    For Customers:
                                </div>
                                <div className=''>
                                    <ul className=' list-disc ml-3 '>
                                        <li>
                                            Provide services, technical support, form design assistance, and technical troubleshooting.

                                        </li>
                                        <li>

                                            Use form data to offer features and personalized content.
                                            Customers can avoid data use by opting out of certain features.
                                        </li>
                                        <li>
                                            Link YR IT SOLUTIONS Pvt Ltd accounts with third-party accounts for additional features and services.

                                        </li>
                                        <li>

                                            Export information to and collect information from third-party applications and websites.
                                        </li>
                                    </ul>

                                </div>
                                <div className=''>
                                    <div className='privacy-sub'>
                                        For Service Management:

                                    </div>
                                    <ul className=' list-disc ml-3 '>
                                        <li>

                                            Monitor, maintain, and improve services and features.
                                        </li>
                                        <li>
                                            Enforce Terms of Use and prevent illegal activities.

                                        </li>
                                        <li>
                                            Create new services, features, or content using form data and metadata. YR IT SOLUTIONS Pvt Ltd prioritizes data security and follows industry standards to protect your information.

                                        </li>
                                        <li>
                                            Screen for and prevent undesirable or abusive activity.
                                        </li>
                                    </ul>
                                </div>


                            </div>
                        </div>


                    </div>
                </div>
                <div className=' font-bold text-[27px] mt-10 max-[670px]:text-[28px] max-[670px]:text-left max-[670px]:font-semibold max-[670px]:mt-6'>
                YR IT SOLUTIONS Pvt Ltd prioritizes data security and follows industry standards to protect your information.
                </div>
            </div>
        </>
    )
}

export default PrivacyPolicy